<template>
	<div>
		<div class="common-form">修改技师</div>
		<div class="product-content">
		  <div class="table-wrap">
		    <el-table size="small" :data="technician" 
		      style="width: 100%">
		      <el-table-column prop="username" label="技师名称" width="180"></el-table-column>
			  <el-table-column prop="address" label="所在地址" ></el-table-column>
			  <el-table-column prop="working_hours" label="服务时间" ></el-table-column>
		     <!-- <el-table-column prop="sort" label="分类排序"></el-table-column>
		      <el-table-column prop="createTime" label="添加时间"></el-table-column> -->
		      <el-table-column fixed="right" label="操作" width="180">
		        <template slot-scope="scope">
				  <el-button type="primary" size="small" v-if="user_id == scope.row.waiter_user_id" >已选择此技师</el-button>
				  <el-button v-else @click="edit(scope.row.waiter_user_id)" type="primary" size="small">是否选择此技师</el-button>
		        </template>
		      </el-table-column>
		    </el-table>
		  </div>
		</div>
	</div>
</template>

<script>
	import Technician from '@/api/technician.js';
	export default {
		components: {},
		data(){
			return {
				technician:[],
				user_id:'',
			}
		},
		created() {
			this.user_id = this.$route.query.user_id
			console.log(this.user_id)
			this.getData()
		},
		methods:{
			getData() {
			  Technician.Technician({}, true)
			    .then(data => {
					this.technician =  data.data.Waiter
					console.log(this.technician)
			    })
			    .catch(error => {
			    });
			},
			edit(e){
				// updateWaiterUserId 更新技师
				console.log(e,this.$route.query.user_id)
				let orderId = this.$route.query.orderId
				let waiter_user_id = e
				Technician.updateWaiterUserId({
					orderId,waiter_user_id
				}, true)
				  .then(data => {
					this.$message({
					  message: data.msg,
					  type: 'success'
					});
					this.$router.push({
					  path: '/order/order/index',
					});
				  })
				  .catch(error => {
				  });
			}
		}
	}
</script>




<style>
.edit_container {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  line-height: 20px;
  color: #2c3e50;
}

.ql-editor {
  height: 400px;
}

.draggable-list {
  display: flex;
  justify-content: flex-start;
  flex-wrap: wrap;
}
.draggable-list .wrapper > span {
  display: flex;
  justify-content: flex-start;
  flex-wrap: wrap;
}

.draggable-list .item {
  position: relative;
  width: 110px;
  height: 110px;
  margin-top: 10px;
  margin-right: 10px;
  border-radius: 8px;
  overflow: hidden;
  border: 1px solid #dddddd;
}

.draggable-list .delete-btn {
  position: absolute;
  top: 0;
  right: 0;
  width: 16px;
  height: 16px;
  background: red;
  line-height: 16px;
  font-size: 16px;
  color: #ffffff;
  display: none;
}

.draggable-list .item:hover .delete-btn {
  display: block;
}

.draggable-list .item img {
  position: absolute;
  top: 50%;
  left: 50%;
  -webkit-transform: translate(-50%, -50%);
  transform: translate(-50%, -50%);
  max-height: 100%;
  max-width: 100%;
}

.draggable-list .img-select {
  display: flex;
  justify-content: center;
  align-items: center;
  border: 1px dashed #dddddd;
  font-size: 30px;
}

.draggable-list .img-select i {
  color: #409eff;
}
</style>



// WEBPACK FOOTER //
// src/views/order/order/some.vue